<script>
export default {
    name: "BitrixImage",
    functional: true,
    props: {
        file: Object,
    },
    methods: {
        getSrc(file) {
            return [process.env.VUE_APP_ROSCONGRESS_URL, 'upload', file.SUBDIR, file.FILE_NAME].join('/');
        }
    },
}
</script>

<template functional>
    <v-img
        v-if="props.file && props.file.SUBDIR && props.file.FILE_NAME"
        v-bind="data.attrs"
        v-on="listeners"
        :src="$options.methods.getSrc(props.file)"
    ></v-img>
</template>

<style scoped lang="scss">

</style>